var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.998,
    height: 50.002,
    viewBox: "0 0 49.998 50.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5639",
    "data-name": "Grupo 5639",
    transform: "translate(-782 -441)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_169",
    "data-name": "Elipse 169",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(793 452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_12",
    "data-name": "Subtra\\xE7\\xE3o 12",
    d: "M8993,14731a24.976,24.976,0,1,1,17.685-7.316A24.844,24.844,0,0,1,8993,14731Zm0-21.477h0l6.477,6.474,3.523-3.523-6.474-6.477,6.474-6.474-3.523-3.527-6.478,6.478-6.474-6.478-3.526,3.527,6.477,6.474-6.477,6.477,3.526,3.523,6.473-6.474Z",
    transform: "translate(-8186 -14240)",
    fill: "#ff4949"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-icon.0693659f.svg";
export { ForwardRef as ReactComponent };